import * as H from 'history';
import { FilterInterface } from '../FilterInterface';
import { FilterValueType } from './FilterEquipService';
import { FilterSerializer } from './FilterSerializer';

export class UrlEquipService {
    private readonly filterSerializer: FilterSerializer;
    private readonly history: H.History;

    constructor(filterSerializer: FilterSerializer, history: H.History) {
        this.filterSerializer = filterSerializer;
        this.history = history;
    }

    public equip<T extends FilterValueType>(filter: FilterInterface<T>) {
        const serializedState = this.filterSerializer.serializeFilterState(filter);
        const parameterName = filter.keyPath;
        const searchParams = new URLSearchParams(this.history.location.search);
        if (serializedState === undefined) {
            searchParams.delete(parameterName);
        } else {
            searchParams.set(parameterName, serializedState);
        }

        this.history.push(
            {
                pathname: this.history.location.pathname,
                search: '' + searchParams,
                state: {some: 'state'}
            }
        );
    }
}
